require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./top-ten-most-wanted.json") })
        }
      }, "path---top-ten-most-wanted");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---top-ten-most-wanted!./.cache/json/top-ten-most-wanted.json
// module id = 1057
// module chunks = 231608221292675